import { CargoOption, EmissionStats, ScheduleFrequencyInterface } from '@/types';
import { SegmentModeType } from '@/types/api-types';
import { tv } from '@/utils/styles';

import { OptionFrequencyChart } from '../frequency-chart';
import { EmissionSummaryCard } from '../summary-card/emissions';
import { MarketRatesSummaryCard } from '../summary-card/market-rates';

export interface OptionSummaryProps {
  originId: string;
  destinationId: string;
  mode: SegmentModeType;
  schedule: ScheduleFrequencyInterface;
  emissions?: EmissionStats;
  secondaryEmissions?: number;
  shouldShowRates?: boolean;
  cargo?: CargoOption;
}

const OptionSummary = ({
  originId,
  destinationId,
  mode,
  schedule,
  emissions,
  secondaryEmissions,
  shouldShowRates,
  cargo,
}: OptionSummaryProps) => {
  const { base, container } = styles();

  return (
    <div className={base()}>
      <div className={container()}>
        <div className="pr-6">
          <OptionFrequencyChart
            schedule={schedule}
            originId={originId}
            destinationId={destinationId}
            mode={mode}
            allowDateSearch
          />
        </div>
        <EmissionSummaryCard emissions={emissions} secondaryEmissions={secondaryEmissions} />
        <MarketRatesSummaryCard
          originId={originId}
          destinationId={destinationId}
          mode={mode}
          cargo={cargo}
          upgradeRequired={!shouldShowRates}
        />
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'border-y border-grey-200 bg-white',
    container: 'grid grid-cols-[3fr_1fr_1fr] gap-4 px-8 py-8',
  },
});

export { OptionSummary };
